import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: undefined,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      // Check if the error is the specific Tiptap error
      if (
        this.state.error?.message.includes('Invalid regular expression: invalid group specifier name') &&
        this.state.error?.stack?.includes('reactjs-tiptap-editor')
      ) {
        // Render an empty fragment or a custom fallback UI for this specific error
        return this.props.fallback !== undefined ? this.props.fallback : <></>;
      }
      // For other errors, you might want to re-throw or render a generic error message
      // For now, let's also return the fallback for any error caught by this boundary
      return this.props.fallback !== undefined ? this.props.fallback : <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
